// Utility sagas for Settings module

// Services
import { ErrorCategory, handleError } from '@services/errorService';

// Utils
import uploadImage from '@utils/uploadImage';

export function* uploadImageSaga(files: Blob): Generator {
  try {
    const uploadFiles = (yield uploadImage(files, 'link')) as string;

    return uploadFiles;
  } catch (error) {
    handleError(error, { category: ErrorCategory.API });
  }
}
